export default __webpack_public_path__ + "static/logo-orano-518b1951c71edb160dec9e6bae52cf66.png";